import * as PIXI from "pixi.js";

const W = 40;
const H = 25;

export enum NavigatorColor {
  default = "0xFFFFFF",
  prev = "0x21D4FE",
  curr = "0xFC99C4",
  true = "0x00FF00",
  false = "0xFF0000",
  null = "0xE0E0E0"
}

export default class QuestionNavigatorRenderer extends PIXI.Container {
  private bg = this.addChild(new PIXI.Graphics());
  private num = this.addChild(new PIXI.Text());

  constructor(number: number) {
    super();
    this.drawBg(NavigatorColor.default);
    this.addNum(number);
  }
  drawBg(color: NavigatorColor) {
    this.bg
      .roundRect(-W / 2, -H / 2, W, H, 3)
      .fill(color)
      .stroke({ width: 1, color: 0x232323 })
  }
  private addNum(number: number) {
    this.num.text = number;
    this.num.anchor.set(.5);
    this.num.style.fontSize = 16;
  }
}